import { combineReducers } from 'redux';
import { reducersLogin} from "./login";
import { reducersToken} from "./token";

export const Reducers = combineReducers({
  stateLogin: reducersLogin,
  stateToken: reducersToken
});